'use strict';

import BaseService from './base.service';

class GroupInvoicesService extends BaseService {
    /* @ngInject */
    constructor(GroupInvoice, SegaUser) {
        super(GroupInvoice, SegaUser);
        Object.assign(this, {
            GroupInvoice
        });
    }

    addQuotes(opts = {quoteIds: [], groupInvoiceId: null}) {
        return this.Model.addQuotes(opts).$promise;
    }
}

export default GroupInvoicesService;
